import { IInputNode, AssessmentNode } from '../../../actionCard'

export class SingleselectAssessmentNode
  extends AssessmentNode
  implements IInputNode<{ id: number; text?: string } | undefined>
{
  public getValue(): { id: number; text: string } | undefined {
    const assessmentValue = this.__getValue()
    const id = assessmentValue.ids[0]
    if (!id) {
      return
    }
    return { id: id, text: assessmentValue.text }
  }

  public setValue(value?: { id?: number; text?: string }): void {
    const oldValue = this.getValue()
    const ids = !!value?.id ? [value.id] : []
    super.__setValue({ ids: ids, text: value?.text ?? '' })
    const newValue = this.getValue()

    this.nodeSettings?.observer?.onValueSet?.(this, newValue, oldValue)
  }

  public getStringValue(): string {
    const value = this.getValue()
    return value ? JSON.stringify(value) : ''
  }

  public setStringValue(value?: string): void {
    if (!value) {
      this.setValue()
      return
    }
    const parsedValue = JSON.parse(value) as { id: number; text?: string }
    this.setValue(parsedValue)
  }
}
